import { render } from "./OwnerOrientedCrb.vue?vue&type=template&id=ff4bdd64&scoped=true"
import script from "./OwnerOrientedCrb.vue?vue&type=script&lang=js"
export * from "./OwnerOrientedCrb.vue?vue&type=script&lang=js"

import "./OwnerOrientedCrb.vue?vue&type=style&index=0&id=ff4bdd64&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff4bdd64"]])

export default __exports__